import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    flexDir: 'row',
    justify: 'space-between',
    pb: 3,
    pr: [2, 0, null, null],
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    flexDir: 'row',
    fontSize: ['lg', null, 'xl'],
    fontWeight: 'normal',
    color: 'white',
    fontFamily: 'heading',
    lineHeight: '19px',
    px: [2, null, 0],
    pb: [2, null, 0],
    pt: 0,
  },
  headerIconButton: {
    color: 'white',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {
    sx: {
      '.state-prior': { color: 'white' },
    },
  },
  headerVsBox: {
    color: 'beta.300',
  },
  bodyStack: {
    color: 'white',
    p: '0',
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'beta.300',
    h: '1.1em',
    ml: '2',
    mb: '0.5',
    w: 'auto',
  },
  scrollButtonGroup: {
    h: '10',
    variant: 'filter',
    boxShadow: 'none',
    ml: '0',
    w: 'full',
  },
  wrapperScrollSgm: {
    w: '100%',
    maxW: '100%',
    gap: '2',
  },
  toMarketButton: {
    sx: {
      _first: {
        _after: {
          display: 'none',
        },
      },
      ':active': {
        _after: {
          pos: 'unset',
        },
      },
      ':hover': {
        _after: {
          display: 'none',
        },
      },
      '&[data-active]': {
        _after: {
          pos: 'relative',
          top: 'unset',
          right: '-2px',
        },
        ':hover': {
          _after: {
            display: 'block',
          },
        },
      },
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    gap: '3',
    mx: ['2', null, '0'],
  },
  accordionStack: {
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bg: 'alpha.100',
    border: 'none',
    borderRadius: 'md',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.35)',
    overflow: 'hidden',
  },
  accordionButton: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'accent',
    ml: '4px',
    w: '99%',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
  },
  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'white',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'white',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    p: '0',
  },
  cancelButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    px: '3',
  },
  clearButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    ml: '3',
    px: '3',
  },
  sgmLogoV2: {
    color: 'blackAlpha.800',
    w: ['3.5em', null, null, '3em'],
    h: ['1.3em', null, null, '1.4em'],
    filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.5))',
  },
  toMarketButtonV2: {
    variant: 'tab',
    color: 'white',
    fontSize: 'sm',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'normal',
    cursor: 'pointer',
    fontFamily: 'heading',
    border: 'none',
    borderRadius: 'none',
    sx: {
      '&&': {
        px: 2,
        ml: 0,
        py: '0',
        h: '8',
        _first: { ml: '2' },
        _last: { mr: 2 },
        _hover: {
          color: 'beta.300',
        },
        borderBottom: '3px solid',
        borderBottomColor: 'transparent',
      },
      '&[data-active]': {
        color: 'beta.300',
        borderBottom: '3px solid',
        borderBottomColor: 'beta.300',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },
  },
  sgmBtn: {
    px: [2.5, null, null, 4],
    sx: {
      'svg[class*="StyledIconBase"]': {
        color: 'blackAlpha.800',
        filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.5))',
        boxSize: ['18px', null, null, 5],
      },
      '&&': {
        _active: {
          bgGradient: 'linear(to-b, blackAlpha.700, blackAlpha.700)',
          boxShadow:
            '0px 1px 0px 0px rgba(255, 255, 255, 0.08), 0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset',
        },
      },
    },
  },
  sgmBtnActive: {
    sx: {
      'svg[class*="StyledIconBase"]': {
        color: 'beta.300',
        boxSize: ['18px', null, null, 5],
        filter: 'drop-shadow(0px 0px 8px rgba(173, 241, 6, 0.5))',
      },
      'svg[class*="chakra-icon"]': {
        color: 'beta.300',
        filter: 'drop-shadow(0px 0px 8px rgba(173, 241, 6, 0.5))',
      },
      '&&': {
        color: 'beta.300',
        bgGradient: 'linear(to-b, blackAlpha.700, blackAlpha.700)',
        boxShadow:
          '0px 1px 0px 0px rgba(255, 255, 255, 0.08), 0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset',
      },
    },

    _after: { display: 'none' },
  },
  scrollButtonGroupV2: {
    h: '10',
    variant: 'filter',
    bg: 'transparent',
    position: 'relative',
  },
  accordionItemActive: {
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset',
    bgGradient: `linear(to-b, alpha.300, alpha.500)`,
  },
};
